import React, { Component } from 'react';
import Styles from '@src/framework/editor/src/page/index/components/editor/index.less';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import i18n from '@i18next/i18n';
import { ButtonType } from './config';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Separator from './separator';
import DropDown from './drop-down';
import _get from 'lodash/get';
import { getTipShowText, getIsText, getIsEmail } from './utils';
import OptionMenu from '@src/framework/frame/components/option-menu';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { TDWVer9Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { getIsChinese } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/language';
import { CANVAS_WRAPPER } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';

interface LinkFloatBarProps {
    addonManager: any;
}

interface LinkFloatBarState {
    isShown: boolean;
    config: any;
    isDropDownExtendShow: boolean;
}

/**
 * 链接悬浮条，点击链接文字时出现
 */
export default class LinkFloatBar extends Component<LinkFloatBarProps, LinkFloatBarState> {
    private floatDom: HTMLSpanElement | null;
    private isMouseEnter: boolean;
    public constructor(props: LinkFloatBarProps) {
        super(props);

        this.state = {
            isShown: false,
            config: {},
            isDropDownExtendShow: false,
        };
    }

    public componentWillUnmount() {
        this.removeListener();
    }

    public shouldComponentUpdate(nextProps: LinkFloatBarProps, nextState: LinkFloatBarState): boolean {
        return Object.keys(nextState.config).length !== 0;
    }

    public render() {
        const display = this.state.isShown ? '' : 'none';
        const { top, left } = this.state.config;
        const floatStyle = { left, top, display };
        const { href } = this.state.config;
        const isChinese = getIsChinese(href);
        const isEmail = getIsEmail(href);

        // 获取不同权限、状态下的工具栏
        const { importConfig } = this.state.config;
        if (!importConfig) return null;
        return (
            <span className={Styles['ppt-link-floatbar-v2']}
                ref={(ref) => {
                    this.floatDom = ref;
                }}
                style={floatStyle}
                onMouseDown={this.preventDefault}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onMouseMove={this.handleMouseMove}
            >
                {importConfig.map((button, index) =>
                    // eslint-disable-next-line implicit-arrow-linebreak
                    this.parseButtonConfig(button, index === importConfig.length - 1, isChinese, isEmail))}
            </span>
        );
    }

    public isMouseEnterBar = () => this.isMouseEnter;
    public show = (newConfig?: any, noNeedRelocate?: boolean) => {
        const newConf = newConfig || this.state.config;
        if (!this.state.isShown) {
            if (browser.isMobile) {
                document.body.addEventListener('touchstart', this.bodyClickHandler);
            } else {
                document.body.addEventListener('click', this.bodyClickHandler);
                // document.body.addEventListener('mousedown', this.handleMouseDown);
            }
            window.addEventListener('resize', this.resize);

            this.setState({
                isShown: true,
                config: newConf,
            }, () => {
                this.adjustMenuLoc(newConf);
            });
        } else {
            this.setState({
                config: newConf,
            }, () => {
                if (!noNeedRelocate) {
                    this.adjustMenuLoc(newConf);
                }
            });
        }
    };

    public hide = () => {
        if (this.state.isShown) {
            // @ts-ignore
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.isShown = false;
            this.setState({
                isShown: false,
                isDropDownExtendShow: false,
            });
            this.removeListener();
            // LinkFloatBar.floatInstance = null;
        }
    };

    public isShown = () => this.state.isShown;

    private bodyClickHandler = (e: MouseEvent) => {
        // 延迟一下，让body里的元素先执行click
        // 非全屏状态下才生效
        if (this.state.isShown && !document.fullscreenElement && !document.querySelector('#addon-modify-modal')) {
            const clickOnMenu = this.clickOnMenu(e, 15);
            if (!clickOnMenu) {
                this.hide();
            }
        }
    };
    // 点击的位置是否在菜单组件上 或者在shape状态时，点击在shape上and menu上
    private clickOnMenu = (e: MouseEvent, maxLevel: number): boolean => {
        let curDom: HTMLElement | null = e.target as HTMLElement;
        let level = 0;
        while (curDom && level < maxLevel) {  // 只查到15层，避免过多查找
            curDom = curDom.parentNode as HTMLElement;
            level += 1;
            // 链接态时，随便点击除工具栏的地方都需要消失
            // 卡片态时，点除工具栏、卡片dom之外的地方才需要消失
            if (!curDom) return false; // 找不到了提前退出
            // 这里因为LinkFloatBar改造为通用组件，默认为Link的点击判断 如果需要其他模式，从config读取并判断
            if (this.state.config.clickElementJudge) {
                if (this.state.config.clickElementJudge(curDom)) {
                    return true;
                }
            } else if (curDom.id === 'link-float-container-id') {
                // 默认模式判断
                return true;
            }
            // 否则继续循环
        }
        return false;
    };
    private handleMouseEnter = () => {
        this.isMouseEnter = true;
    };

    private handleMouseLeave = () => {
        this.isMouseEnter = false;
        // console.log('float bar handleMouseLeave');
        if (this.state.config.handleMouseLeave) {
            this.state.config.handleMouseLeave();
        }
    };

    private handleMouseMove = (e: React.MouseEvent) => {
        // 阻止事件冒泡到上层导致本组件关闭
        e.stopPropagation();
    };

    private onVisibleChange = (visible: boolean) => {
        if (visible) {
            const { addonManager, selectionService } = this.state.config;
            const type = addonManager.addonHandler.getSceneType();
            const aid = selectionService.getSelectedModel()?.props.addon?.docElement.addonId;
            addonManager.addonHandler.updateIframeFloatMenu(type, aid);
        }
    };

    private onAddonItemClick = (id: string) => {
        const tdwOption = {
            ver9: TDWVer9Type.DETAIL_IFRAME_TOOLBAR,
        };
        this.state.config.addonManager.addonHandler.handleAddonSceneItemClick(id, tdwOption);
    };

    private removeListener = () => {
        if (browser.isMobile) {
            document.body.removeEventListener('touchstart', this.bodyClickHandler);
        } else {
            document.body.removeEventListener('click', this.bodyClickHandler);
        }
        window.removeEventListener('resize', this.resize);
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.config.anchorView = null;
    };

    private resize = () => {
        if (browser.isMobile) {
            setTimeout(() => {
                const textSpan = this.state.config.anchorView;
                if (textSpan) {
                    const rect = this.state.config.processFloatBarAnchorRect?.();
                    // eslint-disable-next-line react/no-direct-mutation-state
                    this.state.config.left = rect.left;
                    // eslint-disable-next-line react/no-direct-mutation-state
                    this.state.config.top = rect.top;
                    this.setState({
                        config: this.state.config,
                    });
                }
            }, 200);
        }
    };


    private adjustMenuLoc = (newConfig: any) => {
        const { floatDom } = this;
        if (floatDom && newConfig) {
            let vh = document.body.clientHeight;
            const vw = document.body.clientWidth;

            const rect = floatDom.getBoundingClientRect(); // rect的left和top在移动端可能不对
            // 根据canvas-wrapper调整出现的位置
            const canvasWrapper = document.getElementById(CANVAS_WRAPPER);
            let canvasRect = { left: 0, top: 0 };
            if (canvasWrapper) {
                canvasRect = canvasWrapper.getBoundingClientRect();
                vh = (canvasRect as DOMRect).height;
            }
            newConfig.left -= canvasRect.left;
            newConfig.top -= canvasRect.top;
            if (newConfig.left + rect.width > vw) {  // 右侧空间不足，往左侧显示
                newConfig.left = vw - rect.width;
            }

            if (newConfig.top + rect.height > vh) {
                newConfig.top -= newConfig.height ? (newConfig.height + rect.height + 6) : 0;
            }
            this.setState({
                config: newConfig,
            });
        }
    };

    private preventDefault = (e: React.MouseEvent) => {
        e.preventDefault();
    };

    private handleMouseUp = (id: string) => {
        const oprMap = {
            url: 'openLink',
            copyUrl: 'handleCopyUrl',
            modifyUrl: 'handleModifyUrl',
            refresh: 'handleRefresh',
            delete: 'deleteElement',
            fullscreen: 'handleFullScreen',
            cancelUrl: 'handleLinkRemove',
        }; // 策略模式拆分下
        this.state.config[oprMap[id]]?.();
        this.setState({
            isDropDownExtendShow: false,
        });
    };

    private parseButtonConfig = (button: any, isLastElement: boolean, isChinese: boolean, isEmail: boolean) => {
        const { type, config, id = '', text = '' } = button;

        if (type === ButtonType.SEPARATOR) {
            return (
                <Separator type={config.block} />
            );
        }
        if (type === ButtonType.TOOLTIP) {
            const isText = getIsText(text, isChinese, isEmail);
            const textButtonClass = text ? 'text' : 'normal';
            const last = isLastElement ? '-last' : '';
            const textShow = isText ? _get(this.state, 'config.href') : text;
            const tipTextShow = getTipShowText(isText, isChinese, isEmail, config);
            return (
                <Tooltip
                    placement="top"
                    title={i18n.t(tipTextShow)}
                    visible={browser.isMobile ? false : undefined}
                >
                    <div
                        className={`${Styles[`button-${textButtonClass}`]}
                          ${Styles[`button-${textButtonClass}-${id}`]}
                          ${Styles[`button-${textButtonClass}${last}`]}
                          ppt-link-floatbar-v2-${id}
                          `}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleMouseUp(id);
                        }}
                    >{this.getI18nText(textShow)}</div>
                </Tooltip>
            );
        }
        if (type === ButtonType.DROPDOWN) {
            return (
                <DropDown
                    config={config}
                    isDropDownExtendShow={this.state.isDropDownExtendShow}
                    getModeFromConfigData={this.getModeFromConfigData}
                    onSelectedItemCallback={this.onSelectedItemCallback.bind(this)}
                    showDropDownMenu={this.showDropDownMenu}
                    hideDropDownMenu={this.hideDropDownMenu}
                />
            );
        }
        if (type === ButtonType.DUIDROPDOWN) {
            return (
                <Dropdown
                    trigger="click"
                    alignment="left"
                    dropContentStyle={{
                        boxShadow: '0 2px 12px 2px rgba(68, 73, 77, 0.16)',
                        padding: '0',
                    }}
                    dropContent={
                        <OptionMenu
                            data={config.items}
                            onMenuClick={this.onAddonItemClick}
                            style={{ backgroundColor: '#fff', margin: '0', maxHeight: '100%' }}
                        ></OptionMenu>}
                    onVisibleChange={this.onVisibleChange}>
                    <Tooltip
                        placement="top"
                        title={i18n.t(config.tipText)}
                        visible={browser.isMobile ? false : undefined}
                        style={{ display: 'block' }}
                    >
                        <div className={Styles['link-floatbar-v2-dropdown-button-wrapper-addon']}>
                            <div className={Styles['link-floatbar-v2-dropdown-button-addon']}></div>
                            <div className={Styles['link-floatbar-v2-menu-button-dropdown']}/>
                        </div>
                    </Tooltip>
                </Dropdown>
            );
        }
    };

    private getI18nText = (textShow: string) => {
        const linkToPageNumResult = textShow.match(/链接至幻灯片\s(\d+)/);
        if (Array.isArray(linkToPageNumResult) && linkToPageNumResult[1]) {
            return i18n.t('链接至幻灯片 {0}', { 0: linkToPageNumResult[1] });
        }
        return i18n.t(textShow);
    };

    // 获取config中默认选择的那一项
    private getModeFromConfigData = () => {
        const config = this.state.config.importConfig;
        let displayMode;
        // eslint-disable-next-line array-callback-return
        config.map((_) => {
            if (_.id === 'changeDisplay') {
                displayMode = _.config.items.filter(item => item.isSelected)[0]?.id;
            }
        });
        return displayMode;
    };
    // configMode根据importConfig的select来获取
    private onSelectedItemCallback = (mode: string) => {
        const configMode = this.getModeFromConfigData();
        if (mode !== configMode) {
            this.state.config.handleModeChange(mode);
            this.setState({
                isDropDownExtendShow: false,
            });
            // 每次切换状态后都会重新展示工具栏，此时会自动拉取最新的config，无需在这里更改displayMode
        }
        this.state.config.tdwOnSelectedItemCallback(mode);
    };
    private showDropDownMenu = () => {
        this.setState({
            isDropDownExtendShow: true,
        });
    };

    private hideDropDownMenu = () => {
        this.setState({
            isDropDownExtendShow: false,
        });
    };
}
